import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import './index.css'
import '@cloudscape-design/global-styles/index.css'
// import { applyMode, applyDensity, Density, Mode } from '@cloudscape-design/global-styles';

import App from './App'
import { BrowserRouter } from 'react-router-dom'

import '@fontsource/roboto'
import '@fontsource/inter'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TSClient } from './services/TanStackQuery'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

// apply a color mode
// applyMode(Mode.Dark)
// applyMode(Mode.Light)

// apply a content density mode
// applyDensity(Density.Compact)
// applyDensity(Density.Comfortable)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={TSClient}>
        <BrowserRouter>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App />
          </LocalizationProvider>
        </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()